import { ReorderModal } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <ReorderModal />;
}
